import { aboutStats, aboutAdvantages } from '@/mocks/comics';

export default function BrandSection() {
  return (
    <section className="py-14 md:py-20 bg-accent-100/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-2">
          <span className="inline-block px-4 py-1.5 rounded-full bg-background-50 text-foreground-700 text-sm font-medium whitespace-nowrap">
            关于我们
          </span>
        </div>
        <h1 className="text-3xl md:text-5xl font-bold font-heading text-foreground-900 leading-tight mb-10 whitespace-nowrap">
          韩漫漫画网<br />优质韩漫阅读平台
        </h1>

        <div className="flex flex-wrap gap-8 md:gap-16 mb-14">
          {aboutAdvantages.map((adv) => (
            <div key={adv.id}>
              <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{adv.title}</h3>
              <p className="text-xs text-foreground-500 mt-1 max-w-[160px]">{adv.description}</p>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap gap-8 md:gap-16">
          {aboutStats.map((stat, i) => (
            <div key={i}>
              <p className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 whitespace-nowrap">
                {stat.value}
                <span className="text-lg md:text-xl font-normal text-foreground-500 ml-1">{stat.suffix}</span>
              </p>
              <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
